import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TeamService} from '../service/teamService';
import {RedirectInvitation} from "../enums/RedirectInvitation";
import {InvitationRoutes} from "../constants/routes";
import {InvitationResponse} from "../interface/InvitationResponse";
import {InvitationTokenService} from "../service/invitation-token.service";
import {catchError, of} from "rxjs";

@Component({
  selector: 'app-accept-or-declined',
  templateUrl: './accept-or-declined.component.html',
  styleUrls: ['./accept-or-declined.component.scss']
})
export class AcceptOrDeclinedComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private teamService: TeamService,
    private invitationTokenService: InvitationTokenService
  ) {
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const {token, email} = params;
      const accepted = params['accepted'] === 'true';
      this.teamService.acceptInvitation(token, accepted, email)
        .pipe(
          catchError(() => {
            this.router.navigate(['/error-page']);
            return of(null);
          })
        )
        .subscribe(response => {
          if (response) {
            this.navigateToRoute(response, token);
          }
        });
    });
  }

  private navigateToRoute(response: InvitationResponse, token: string): void {
    if (response.error) {
      console.error(response.error);
      return;
    }

    const redirect = response.redirectInvitation;
    const route = redirect
      ? ({
          [RedirectInvitation.REGISTRATION]: InvitationRoutes.SIGN_UP,
          [RedirectInvitation.TEAM]: InvitationRoutes.TEAM,
          [RedirectInvitation.LOGIN]: InvitationRoutes.LOGIN,
        }[redirect] ?? InvitationRoutes.HOME)
      : InvitationRoutes.HOME;

    if (redirect === RedirectInvitation.REGISTRATION) {
      this.router.navigate([route], { queryParams: { token } });
    } else if (redirect === RedirectInvitation.TEAM) {
      this.router.navigate([route], { queryParams: { teamId: response.teamId } });
    } else if (redirect === RedirectInvitation.LOGIN) {
      if (response.teamId) {
        this.invitationTokenService.setPendingTeamId(response.teamId);
      }
      this.router.navigate([route], { state: { isNavigateToTeamPageAfterLogin: true } });
    } else {
      this.router.navigate([route]);
    }
  }
}
